// extracted by mini-css-extract-plugin
export default {"center":"dSx8Tl","messageModalLayout":"M1dwjG","opacityLayer":"FmTjWv"};